import { Loader2, Square } from "lucide-react";

// Confirmation shown by the reports sidebar when the user clicks away from a
// report whose generation is still streaming. Styled after PopUpLogOut.
const LeaveGeneratingReportModal = ({ onStay, onLeave }) => (
  <div className="relative">
    <div
      aria-hidden
      className="pointer-events-none absolute -inset-6 -z-10 rounded-3xl bg-[radial-gradient(ellipse_at_center,var(--tw-gradient-stops))] from-velBlue/20 to-transparent opacity-70 blur-2xl"
    />
    <div
      role="dialog"
      aria-labelledby="leave-report-title"
      className="w-[min(92vw,440px)] rounded-lg border border-surfaceBorder bg-surface/80 font-poppins font-normal shadow-login-panel backdrop-blur-md"
    >
      <div className="space-y-4 px-6 py-6">
        <div className="flex items-center gap-2">
          <Loader2
            className="h-5 w-5 animate-spin text-velBlue"
            strokeWidth={2}
            aria-hidden
          />
          <h3
            id="leave-report-title"
            className="text-sm font-medium text-mainText"
          >
            Report still generating
          </h3>
        </div>

        <p className="text-sm text-mutedText">
          Leaving now stops the report that is being generated. It can't be
          resumed, so you'd have to start it again.
        </p>

        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onStay}
            className="cursor-pointer rounded-lg border border-btnBorder bg-transparent px-4 py-2.5 text-sm text-mainText outline-none ring-inputFocus/60 transition hover:bg-btnHover focus-visible:ring-2"
          >
            Keep generating
          </button>
          <button
            type="button"
            onClick={onLeave}
            className="cursor-pointer rounded-lg border border-logoutColor/40 bg-logoutColor/10 px-4 py-2.5 text-sm text-logoutColor outline-none ring-logoutColor/60 transition hover:bg-logoutColor/20 focus-visible:ring-2"
          >
            <span className="flex items-center gap-2">
              <Square className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden />
              Stop and leave
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default LeaveGeneratingReportModal;
